import React, { useState, useEffect } from 'react';
import './Astrology.css';
import { fetchChart } from '../api';

const Astrology = () => {
  const [selectedHouse, setSelectedHouse] = useState(1);
  const [reflectionText, setReflectionText] = useState("");
  const [houses, setHouses] = useState({})
  const [loaded, setLoaded] = useState(false)

  const autoExpand = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 300) + 'px';
  };

  const navigateHouse = (direction) => {
    if (direction === 'left' && selectedHouse > 1) {
      setSelectedHouse(selectedHouse - 1);
    } else if (direction === 'right' && selectedHouse < 12) {
      setSelectedHouse(selectedHouse + 1);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') {
      navigateHouse('left');
    } else if (e.key === 'ArrowRight') {
      navigateHouse('right');
    }
  };

  useEffect(() => {
    let isMounted = true;
  
    const fetchHouses = async () => {
      try {
        const response = await fetchChart();
        const result = await response.chart;
        console.log(result)
        if (isMounted) {
          setHouses(result);
          setLoaded(true);
        }
      } catch (error) {
        console.error('Error fetching houses:', error);
        if (isMounted) {
          setLoaded(true);
        }
      }
    };
  
    fetchHouses();
  
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedHouse]);


  if (!loaded) {
    <div className="astrology-container">
    <header className="astrology-header">
      <h1 className="astrology-title">Houses</h1>
      <p className="astrology-subtitle">Your cosmic blueprint</p>
    </header>
    </div>
  } else {

  const currentHouse = houses[selectedHouse];
  const houseOrdinals = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelfth'];
  const houseOrdinal = houseOrdinals[selectedHouse - 1];

  return (
    <div className="astrology-container">
      
      <header className="astrology-header">
        <h1 className="astrology-title">Houses</h1>
        <p className="astrology-subtitle">Your cosmic blueprint</p>
      </header>

      <nav className="houses-nav">
        {Object.entries(houses).map(([houseNum, house]) => (
          <button
            key={houseNum}
            className={`house-nav-item ${selectedHouse === parseInt(houseNum) ? 'active' : ''}`}
            onClick={() => setSelectedHouse(parseInt(houseNum))}
          >
            <div className="house-number">{houseNum}</div>
            <div className="house-sign">{house.sign.slice(0, 3)}</div>
          </button>
        ))}
      </nav>

      <div className="nav-controls">
        <button 
          className="nav-button" 
          onClick={() => navigateHouse('left')}
          disabled={selectedHouse === 1}
        >
          ←
        </button>
        <span className="current-house-indicator">
          {selectedHouse} of 12
        </span>
        <button 
          className="nav-button" 
          onClick={() => navigateHouse('right')}
          disabled={selectedHouse === 12}
        >
          →
        </button>
      </div>

      <div className="house-content">
        <section className="house-main" style={{ whiteSpace: 'pre-line' }}>
          <h2 className="house-title">{'House ' + selectedHouse}</h2>
          <p className="house-subtitle-text">{'A house of ' + ['Dharma', 'Artha', 'Kama', 'Moksha'][selectedHouse % 4]}</p>
          <p className="house-description">{currentHouse.overview + '\n\n' + currentHouse.overviewPersonalized}</p>
          
          <div className="sign-section" style={{ whiteSpace: 'pre-line' }}>
            <h3 className="sign-title">{currentHouse.sign.toLowerCase()} in the {houseOrdinal} house</h3>
            <p className="sign-message">{currentHouse.signMessage + '\n\n' + currentHouse.signMessagePersonalized}</p>
          </div>
        </section>

        <section className="planets-section" style={{ whiteSpace: 'pre-line' }}>
          {Object.entries(currentHouse.planets).map(([planetKey, planet]) => (
            <div key={planet} className="planet-item">
              <h4 className="planet-name">{planetKey.toLowerCase()}</h4>
              <p className="planet-description">
                {planet.messageBase + '\n\n' + planet.message}
              </p>
            </div>
          ))}
        </section>

        {/* <section className="reflection-section">
          <p className="reflection-question">{currentHouse.question}</p>
          <textarea
            className="reflection-textarea"
            value={reflectionText}
            onChange={(e) => {
              setReflectionText(e.target.value);
              autoExpand(e);
            }}
            onInput={autoExpand}
            placeholder="Your reflections..."
            style={{ height: 'auto', minHeight: '120px' }}
          />
        </section> */}
      </div>

    </div>
  );
}
};

export default Astrology;